// Client metadata sent to the feedback Typeforms as hidden fields, so each
// response (and the GitHub issue Typeform files from it) says exactly which
// client, OS, app version and page it came from. Keys match the mobile app's
// builder (votemate-mobile-app/src/utils/feedbackMetadata.ts).

export type FeedbackFields = Record<string, string>;

const MAX_VALUE_LENGTH = 100;

// Each value becomes one line in the GitHub issue Typeform files, so keep it
// single-line and short.
const sanitize = (value: string): string =>
  value.replace(/\s+/g, ' ').trim().slice(0, MAX_VALUE_LENGTH);

/** Drops empty values and sanitizes the rest, keeping key order. */
export const buildFeedbackFields = (
  input: Record<string, string | null | undefined>
): FeedbackFields => {
  const fields: FeedbackFields = {};
  for (const [key, raw] of Object.entries(input)) {
    if (raw == null) continue;
    const value = sanitize(raw);
    if (value) fields[key] = value;
  }
  return fields;
};

/** Query string for a form.typeform.com/to/{id} URL. */
export const toTypeformQuery = (fields: FeedbackFields): string =>
  Object.entries(fields)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
